import React from "react";
import "./style/LiveBadge.css";

const LiveBadge = () => {
  return (
    <>
        <div style={{ display: "flex", flexDirection: "row", position: "absolute", top: 80, zIndex: 10 }}>
            <div
                className="live-badge"
                style={{
                clipPath: "polygon(0 100%, calc(100% - 12px) 100%, 100% 0, 0 0)",
                }}
            >
                <span className="live-badge-dot-wrapper">
                <span className="live-badge-dot-pulse"></span>
                <span className="live-badge-dot"></span>
                </span>
                <span className="live-badge-label">Live</span>
            </div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                }}
            ></div>            
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.85)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.65)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.45)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.35)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.25)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.15)"
                }}
            ></div>
            <div
                className="badge-item"
                style={{
                    clipPath: "polygon(12px 100%, calc(100% - 12px) 100%, 100% 0, 24px 0)",
                    backgroundColor: "rgba(246, 51, 51, 0.05)"
                }}
            ></div>
        </div>
    </>
  );
};

export default LiveBadge;
